export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-[11px] sm:text-xs font-semibold tracking-[0.3em] uppercase text-cyan ${className}`}>{children}</p>
);
